import type { BaseSelection, Editor, Point } from 'slate';
import { Node, Text } from 'slate';

export function getNextPoint(editor: Editor, point: Point | undefined) {
  while (point) {
    const node = Node.get(editor, point.path);
    if (node) {
      if (Text.isText(node)) {
        const overflowLength = point.offset - node.text.length;
        if (overflowLength > 0) {
          point = editor.after(point);

          if (point) {
            point.offset = overflowLength;
          }
        } else {
          return point;
        }
      } else {
        return point;
      }
    } else {
      return editor.end([]);
    }
  }

  return editor.end([]);
}

export function repairSelection(editor: Editor) {
  let selection: BaseSelection | undefined;
  return {
    save() {
      ({ selection } = editor);
    },
    repair() {
      if (selection) {
        editor.select(getNextPoint(editor, selection.anchor));
      }
    },
  };
}
